/*!
 * Copyright (c) 2018 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';

var _slicedToArray = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/inherits");

var LinkedDataSignature = require('./LinkedDataSignature');

var jsonld = require('jsonld');

var util = require('../util');

module.exports =
/*#__PURE__*/
function (_LinkedDataSignature) {
  _inherits(JwsLinkedDataSignature, _LinkedDataSignature);

  /**
   * @param type {string} Provided by subclass.
   * @param alg {string} JWS alg provided by subclass.
   * @param [LDKeyClass] {LDKeyClass} provided by subclass or subclass
   *   overrides `getVerificationMethod`.
   *
   * One of these parameters is required to use a suite for signing:
   *
   * @param [creator] {string} A key id URL to the paired public key.
   * @param [verificationMethod] {string} A key id URL to the paired public key.
   *
   * This parameter is required for signing:
   *
   * @param [signer] {function} an optional signer.
   *
   * Advanced optional parameters and overrides:
   *
   * @param [proof] {object} a JSON-LD document with options to use for
   *   the `proof` node (e.g. any other custom fields can be provided here
   *   using a context different from security-v2).
   * @param [date] {string|Date} signing date to use if not passed.
   * @param [key] {LDKeyPair} an optional crypto-ld KeyPair.
   * @param [useNativeCanonize] {boolean} true to use a native canonize
   *   algorithm.
   */
  function JwsLinkedDataSignature() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        type = _ref.type,
        alg = _ref.alg,
        LDKeyClass = _ref.LDKeyClass,
        creator = _ref.creator,
        verificationMethod = _ref.verificationMethod,
        signer = _ref.signer,
        key = _ref.key,
        proof = _ref.proof,
        date = _ref.date,
        useNativeCanonize = _ref.useNativeCanonize;

    _classCallCheck(this, JwsLinkedDataSignature);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(JwsLinkedDataSignature).call(this, {
      type: type,
      creator: creator,
      verificationMethod: verificationMethod,
      proof: proof,
      date: date,
      useNativeCanonize: useNativeCanonize
    }));
    _this.alg = alg;
    _this.LDKeyClass = LDKeyClass;
    _this.signer = signer;

    if (key) {
      if (verificationMethod === undefined && creator === undefined) {
        var publicKey = key.publicNode();

        if (publicKey.owner) {
          // use legacy signature terms
          _this.creator = publicKey.id;
        } else {
          // use newer signature terms
          _this.verificationMethod = publicKey.id;
        }
      }

      _this.key = key;

      if (typeof key.signer === 'function') {
        _this.signer = key.signer();
      }

      if (typeof key.verifier === 'function') {
        _this.verifier = key.verifier();
      }
    }

    return _this;
  }
  /**
   * @param verifyData {Uint8Array}.
   * @param proof {object}
   *
   * @returns {Promise<{object}>} the proof containing the signature value.
   */


  _createClass(JwsLinkedDataSignature, [{
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(_ref2) {
        var verifyData, proof, header, encodedHeader, data, signature, encodedSignature;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verifyData = _ref2.verifyData, proof = _ref2.proof;

                if (this.signer && typeof this.signer.sign === 'function') {
                  _context.next = 3;
                  break;
                }

                throw new Error('A signer API has not been specified.');

              case 3:
                // JWS header
                header = {
                  alg: this.alg,
                  b64: false,
                  crit: ['b64']
                };
                /*
                +-------+-----------------------------------------------------------+
                | "b64" | JWS Signing Input Formula                                 |
                +-------+-----------------------------------------------------------+
                | true  | ASCII(BASE64URL(UTF8(JWS Protected Header)) || '.' ||     |
                |       | BASE64URL(JWS Payload))                                   |
                |       |                                                           |
                | false | ASCII(BASE64URL(UTF8(JWS Protected Header)) || '.') ||    |
                |       | JWS Payload                                               |
                +-------+-----------------------------------------------------------+
                */
                // create JWS data and sign

                encodedHeader = util.encodeBase64Url(JSON.stringify(header));
                data = util.createJws({
                  encodedHeader: encodedHeader,
                  verifyData: verifyData
                });
                _context.next = 8;
                return this.signer.sign({
                  data: data
                });

              case 8:
                signature = _context.sent;
                // create detached content signature
                encodedSignature = util.encodeBase64Url(signature);
                proof.jws = encodedHeader + '..' + encodedSignature;
                return _context.abrupt("return", proof);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sign(_x) {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
    /**
     * @param verifyData {Uint8Array}.
     * @param verificationMethod {object}.
     * @param document {object} the document the proof applies to.
     * @param proof {object} the proof to be verified.
     * @param purpose {ProofPurpose}
     * @param documentLoader {function}
     * @param expansionMap {function}
     *
     * @returns {Promise<{boolean}>} Resolves with the verification result.
     */

  }, {
    key: "verifySignature",
    value: function () {
      var _verifySignature = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(_ref3) {
        var verifyData, verificationMethod, proof, _proof$jws$split, _proof$jws$split2, encodedHeader, encodedSignature, header, signature, data, verifier, key;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                verifyData = _ref3.verifyData, verificationMethod = _ref3.verificationMethod, proof = _ref3.proof;
                // add payload into detached content signature
                _proof$jws$split = proof.jws.split('.'), _proof$jws$split2 = _slicedToArray(_proof$jws$split, 3), encodedHeader = _proof$jws$split2[0],
                /*payload*/
                encodedSignature = _proof$jws$split2[2];
                _context2.prev = 2;
                header = JSON.parse(util.decodeBase64UrlToString(encodedHeader));
                _context2.next = 9;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](2);
                throw new Error('Could not parse JWS header; ' + _context2.t0);

              case 9:
                if (header && typeof header === 'object') {
                  _context2.next = 11;
                  break;
                }

                throw new Error('Invalid JWS header.');

              case 11:
                if (!(!(header.alg === this.alg && header.b64 === false && Array.isArray(header.crit) && header.crit.length === 1 && header.crit[0] === 'b64') && Object.keys(header).length === 3)) {
                  _context2.next = 13;
                  break;
                }

                throw new Error("Invalid JWS header parameters for ".concat(this.type, "."));

              case 13:
                // do signature verification
                signature = util.decodeBase64Url(encodedSignature);
                data = util.createJws({
                  encodedHeader: encodedHeader,
                  verifyData: verifyData
                });
                verifier = this.verifier;

                if (verifier) {
                  _context2.next = 21;
                  break;
                }

                _context2.next = 19;
                return this.LDKeyClass.from(verificationMethod);

              case 19:
                key = _context2.sent;
                verifier = key.verifier();

              case 21:
                return _context2.abrupt("return", verifier.verify({
                  data: data,
                  signature: signature
                }));

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 6]]);
      }));

      function verifySignature(_x2) {
        return _verifySignature.apply(this, arguments);
      }

      return verifySignature;
    }()
  }, {
    key: "assertVerificationMethod",
    value: function () {
      var _assertVerificationMethod = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(_ref4) {
        var verificationMethod;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                verificationMethod = _ref4.verificationMethod;

                if (jsonld.hasValue(verificationMethod, 'type', this.requiredKeyType)) {
                  _context3.next = 3;
                  break;
                }

                throw new Error("Invalid key type. Key type must be \"".concat(this.requiredKeyType, "\"."));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function assertVerificationMethod(_x3) {
        return _assertVerificationMethod.apply(this, arguments);
      }

      return assertVerificationMethod;
    }()
  }, {
    key: "getVerificationMethod",
    value: function () {
      var _getVerificationMethod = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(_ref5) {
        var proof, documentLoader, verificationMethod;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                proof = _ref5.proof, documentLoader = _ref5.documentLoader;

                if (!this.key) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return", this.key.publicNode());

              case 3:
                _context4.next = 5;
                return _get(_getPrototypeOf(JwsLinkedDataSignature.prototype), "getVerificationMethod", this).call(this, {
                  proof: proof,
                  documentLoader: documentLoader
                });

              case 5:
                verificationMethod = _context4.sent;
                _context4.next = 8;
                return this.assertVerificationMethod({
                  verificationMethod: verificationMethod
                });

              case 8:
                return _context4.abrupt("return", verificationMethod);

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getVerificationMethod(_x4) {
        return _getVerificationMethod.apply(this, arguments);
      }

      return getVerificationMethod;
    }()
  }, {
    key: "matchProof",
    value: function () {
      var _matchProof = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(_ref6) {
        var proof, document, purpose, documentLoader, expansionMap, verificationMethod;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                proof = _ref6.proof, document = _ref6.document, purpose = _ref6.purpose, documentLoader = _ref6.documentLoader, expansionMap = _ref6.expansionMap;
                _context5.next = 3;
                return _get(_getPrototypeOf(JwsLinkedDataSignature.prototype), "matchProof", this).call(this, {
                  proof: proof,
                  document: document,
                  purpose: purpose,
                  documentLoader: documentLoader,
                  expansionMap: expansionMap
                });

              case 3:
                if (_context5.sent) {
                  _context5.next = 5;
                  break;
                }

                return _context5.abrupt("return", false);

              case 5:
                if (this.key) {
                  _context5.next = 7;
                  break;
                }

                return _context5.abrupt("return", true);

              case 7:
                verificationMethod = proof.verificationMethod;

                if (!verificationMethod) {
                  verificationMethod = proof.creator;
                } // only match if the key specified matches the one in the proof


                if (!(typeof verificationMethod === 'object')) {
                  _context5.next = 11;
                  break;
                }

                return _context5.abrupt("return", verificationMethod.id === this.key.id);

              case 11:
                return _context5.abrupt("return", verificationMethod === this.key.id);

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function matchProof(_x5) {
        return _matchProof.apply(this, arguments);
      }

      return matchProof;
    }()
  }]);

  return JwsLinkedDataSignature;
}(LinkedDataSignature);